/*!
 * numbro.js language configuration
 * language : Estonian
 * locale: Estonia
 * author : Illimar Tambek : https://github.com/ragulka
 *
 * Note: in Estonian, abbreviations are always separated
 * from numbers with a space
 */
(function () {
  'use strict';

  var language = {
    langLocaleCode: 'et-EE',
    cultureCode: 'et-EE',
    delimiters: {
      thousands: ' ',
      decimal: ','
    },
    abbreviations: {
      thousand: ' tuh',
      million: ' mln',
      billion: ' mld',
      trillion: ' trl'
    },
    ordinal: function ordinal() {
      return '.';
    },
    currency: {
      symbol: '€',
      position: 'postfix'
    },
    defaults: {
      currencyFormat: ',4 a'
    },
    formats: {
      fourDigits: '4 a',
      fullWithTwoDecimals: ',0.00 $',
      fullWithTwoDecimalsNoCurrency: ',0.00',
      fullWithNoDecimals: ',0 $'
    }
  };

  // CommonJS
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = language;
  }
  // Browser
  if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
    window.numbro.culture(language.cultureCode, language);
  }
}).call(typeof window === 'undefined' ? this : window);